<script lang="ts">
	import { Map, Marker } from "@beyonk/svelte-mapbox";
	import Route from "./path.svelte";

	let mapComponent;
	var telemetry = {
		temp: 0,
		humidity: 0,
		alt: 0,
		avgSpeedKmh: 0,
		avgSpeedMps: 0,
	};
	
	
	let pathHistory = [];
	let hasBeenCentered = false;

	setInterval(async () => {
		let get1 = await fetch("https://locapi.czop.ru/getlastdata")
		let get2 = await fetch("https://locapi.czop.ru/gethistory")
		let last = await get1.json();
		let history = await get2.json();
		pathHistory = history.data
		if (last.status === 500) {
			return;
		}
		let data = last.data
		lng = data.lng
		cnlng = data.lng
		lat = data.lat
		cnlat = data.lat
		if (!hasBeenCentered) {
			mapComponent.flyTo({center: [cnlng, cnlat]})
			hasBeenCentered = true;
		}
		telemetry.temp = data.temp
		telemetry.humidity = data.humid
		telemetry.alt = data.alt
		telemetry.avgSpeedKmh = data.kmh
		telemetry.avgSpeedMps = data.mps
	}, 2500)

	$: lng = 21.037631;
	$: lat = 52.493363;
	$: cnlng = 21.057;
	$: cnlat = 52.49;

	function onReady() {
    	mapComponent.setCenter([cnlng, cnlat]);
		mapComponent.setZoom(12.5);
	}

</script>

<main>
	<div class="h-screen">
		<Map 
			accessToken="pk.eyJ1IjoibXJ0YWxvbjYzIiwiYSI6ImNrdjEzNXVxcjNra3EybnM3ZXByMTR4N2QifQ.Qr4a0gOKag7p8l_rLmrUmw"
			style="mapbox://styles/mrtalon63/ckvl9k0xu3w1r15tjjooq6e1w"
			bind:this={mapComponent} 
  			on:ready={onReady}
		>
			<Route cords={pathHistory}/>
			<Marker
				lat={lat}
				lng={lng}
			>
				<div class="marker"></div>
				<div class="content" slot="popup">
					<h2 class="text-center">Telemetria:</h2>
					<ul>
						<li>Średnia prędkość: {telemetry.avgSpeedKmh} km/h</li>
						<li>Średnia temperatura: {telemetry.temp} C</li>
						<li>Średnia wilgotność: {telemetry.humidity}%</li>
						<li>Wysokość: {telemetry.alt}m</li>
						<li><a href="https://www.google.com/maps/search/?api=1&query={lat},{lng}" target="_blank">Link do Google Maps</a></li>
					</ul>
				</div>
			</Marker>
		</Map>
	</div>
</main>


<style>
    :global(.mapboxgl-map) {
        height: 200px;
    }
	:global(.mapboxgl-marker){
      cursor: pointer;
    } 
	.marker {
		background-image: url(https://cdn.discordapp.com/attachments/855883086041448450/905904795238404176/Bez_nazwy_1.png);
		height: 64px;
		width: 64px;
	}
</style>

